export default function MenuIcon() {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24">
      <path d="M2 6c0-.6.4-1 1-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM2 12c0-.5.4-1 1-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM3 17a1 1 0 100 2h18a1 1 0 000-2H3z" />
    </svg>
  );
}
